/**
 * 对话页的代码分包。路由懒加载和首页预加载共用这一个入口(浏览器对同一模块只下一次)。
 *
 * 首页一打开就调它:线上网慢时(2026-10-30 实测 23–42KB/s,偶发卡几十秒),
 * 以前要等点了「发送」才开始下对话页代码,React Router 在下完之前一直停在首页,
 * 看起来就是「点发送没反应」。
 */
export function loadAgentConversation(): Promise<
  typeof import("./AgentConversation")
> {
  return import("./AgentConversation");
}
